"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var field_1 = require("../../../../components/pricing/layout/field/field");

var label_1 = require("../../../../components/pricing/text/label/label");

var theme_pricing_system_1 = require("../../../../theming/theme.pricing-system");

var PickerField = function (_super) {
  __extends(PickerField, _super);

  function PickerField() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderPickerItems = function () {
      var items = _this.props.items;
      return items.map(function (item) {
        return react_1.default.createElement(react_native_1.Picker.Item, {
          label: item.text,
          value: item.value,
          key: item.value
        });
      });
    };

    _this.onValueChange = function (value) {
      var onSelect = _this.props.onSelect;

      if (onSelect) {
        var selectedItem = _this.props.items.find(function (item) {
          return item.value === value;
        });

        onSelect(selectedItem);
      }
    };

    return _this;
  }

  PickerField.prototype.render = function () {
    return react_1.default.createElement(field_1.Field, {
      viewStyle: this.props.viewStyle,
      errorMessage: this.props.errorMessage
    }, react_1.default.createElement(label_1.Label, {
      label: this.props.label,
      position: this.props.labelPosition,
      textStyle: this.props.labelTextStyle
    }, react_1.default.createElement(react_native_1.Text, {
      style: theme_pricing_system_1.pricingStyles.pickerFieldTextStyle
    }, react_1.default.createElement(react_native_1.Picker, {
      style: this.props.pickerViewStyle,
      onValueChange: this.onValueChange,
      selectedValue: this.props.selectedItemValue
    }, this.renderPickerItems()))));
  };

  return PickerField;
}(react_1.default.PureComponent);

exports.PickerField = PickerField;